/**
 * @generated SignedSource<<eab85c588d30f8bf66c4d59dd8f5d2a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsIntegrationCategoryRoute_organization$data = {
  readonly id: any;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsIntegrationCategoryContent_organization">;
  readonly " $fragmentType": "SettingsIntegrationCategoryRoute_organization";
};
export type SettingsIntegrationCategoryRoute_organization$key = {
  readonly " $data"?: SettingsIntegrationCategoryRoute_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsIntegrationCategoryRoute_organization">;
};

import SettingsIntegrationCategoryRouteRefetchQuery_graphql from './SettingsIntegrationCategoryRouteRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": SettingsIntegrationCategoryRouteRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "SettingsIntegrationCategoryRoute_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsIntegrationCategoryContent_organization"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "GraphQLOrganization",
  "abstractKey": null
};

(node as any).hash = "8ebabe2f40e91add4604a6e4424bd08a";

export default node;
